import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createShallowStoreHook } from './createShallowStoreHook';
import { Database } from '@fd/supabase/databaseTypes';

type CouponType = {
  code: string;
  type: 'percentage' | 'fixed_amount';
  discountValue: number;
};

type PaymentGatewayType = Database['public']['Enums']['payment_gateway'];

type PaymentDetailsType = {
  paymentMethod: PaymentGatewayType;
  coupon?: CouponType;
};

type PaymentDetailsStoreType = PaymentDetailsType & {
  setPaymentMethod: (paymentMethod: PaymentGatewayType) => void;
  setCoupon: (coupon?: CouponType) => void;
};

const initialState: PaymentDetailsType = {
  paymentMethod: 'paddle',
};

export const usePaymentDetailsStore = create<PaymentDetailsStoreType>()(
  persist(
    (set) => ({
      ...initialState,
      setPaymentMethod: (paymentMethod) => set({ paymentMethod }),
      setCoupon: (coupon) => set({ coupon }),
    }),
    {
      name: 'calculator-form-local-storage',
    }
  )
);

const usePaymentDetails = createShallowStoreHook(usePaymentDetailsStore);

export default usePaymentDetails;

export const calculatePaidUntilDateMonths = (monthsPaid: 1 | 12) => {
  const date = new Date();
  return new Date(date.setMonth(date.getMonth() + monthsPaid));
};
